
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
XHeader,
Tab,
TabItem,
Swiper,
SwiperItem,
Group,
Cell
},
data() {
return {
tabIndex: 0,
collectionList: [],
writeNoteList: []
};
},
created() {
this.getData();
},
methods: {
getData() {
this.$http({
method: "post",
url: "wxexam.ashx?op=LoadChapterListForSelectSubject",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
showTime: this.GLOBAL.SubjectShowTime.TestInCollect
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.collectionList = response.data.data;
}
})
.catch(function(error) {
console.log("error:" + error);
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadChapterListForSelectSubject",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
showTime: this.GLOBAL.SubjectShowTime.TestInWriteNote
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.writeNoteList = response.data.data;
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
clickCollection(course) {
this.$router.push({
path: "/ChapterSubjectList",
query: {
showtime: this.GLOBAL.SubjectShowTime.TestInCollect,
errtype: this.errType,
errobj: this.GLOBAL.SubjectErrObj.Chapter,
errvalue: course.ichapterid,
chapterid:course.ichapterid,
title:course.cchaptername
}
});








},
clickWriteNote(course) {
this.$router.push({
path: "/ChapterSubjectList",
query: {
showtime: this.GLOBAL.SubjectShowTime.TestInWriteNote,
errtype: this.errType,
errobj: this.GLOBAL.SubjectErrObj.Chapter,
errvalue: course.ichapterid,
chapterid:course.ichapterid,
title:course.cchaptername
}
});








}
},
computed: {
swiperHeight: function() {
return document.documentElement.clientHeight - 90 + "px";
}
}
};



// WEBPACK FOOTER //
// ./src/components/WriteNoteList.vue